export default __webpack_public_path__ + "static/media/prancheta-concluido.cacf08bb.png";